export default "__VITE_ASSET__BuFyRSeU__"